<ng-container *transloco="let t">
  @if (errorMessage$ | async; as errorMessage) {
    <div>
      <span>{{ t(errorMessage) }}.</span>
      <button
        ejs-button
        cssClass="e-btn e-primary custom-btn"
        (click)="reloadPage()"
        >
        {{ t('Try Again') }}
      </button>
    </div>
  }
</ng-container>
